import { z } from "zod";

export const SignInFormSchema = z.object({
  email: z.string().min(1, "Email is required").email(),
  password: z.string().min(8, "Password must be at least 8 characters long"),
});

export type SignInFormValues = z.infer<typeof SignInFormSchema>;
